import pick from 'lodash/pick';
import omit from 'lodash/omit';
import mapValues from 'lodash/mapValues';
import isPlainObject from 'lodash/isPlainObject';
import forEach from 'lodash/forEach';
import mimer from 'mimer';

export function resolveTo(...segments) {
  const { origin, pathname } = window.location;
  let url = new URL(`${origin}${pathname.replace(/\/$/, '')}/`);

  segments.forEach((s) => {
    url = new URL(s, url);
  });

  return url.pathname.replace(/\/$/, '');
}

export function numToLetter(num, uppercase = false) {
  const l = String.fromCharCode(97 + parseInt(num, 10));

  return uppercase ? l.toUpperCase() : l;
}

export function recursiveMap(src, fn = (v) => v) {
  const t = (value, key) => {
    const val = fn(value, key);

    if (isPlainObject(val)) {
      return mapValues(val, (v, k) => t(v, k));
    }

    if (Array.isArray(val)) return val.map((v) => t(v));

    return val;
  };

  return t(src);
}

function flat(object) {
  const result = {};

  function flatten(obj, prefix) {
    prefix = prefix || '';

    forEach(obj, (value, key) => {
      if (Array.isArray(value)) {
        forEach(value, (v, k) => {
          flatten(v, `${prefix}${key}[${k}].`);
        });
      } else if (isPlainObject(value)) {
        flatten(value, `${prefix}${key}.`);
      } else {
        result[prefix + key] = value;
      }
    });
  }

  flatten(object);

  return result;
}

export function initFormValues(defaults, stored = {}, {
  omitIds = true,
} = {}) {
  // parse data into formik friendly format
  const values = recursiveMap(
    { ...defaults, ...stored },
    (val) => {
      if (omitIds) {
        if (isPlainObject(val)) return omit(val, '_id');
      }

      // formik doesn't support numbers very well
      if (typeof val === 'number') {
        return val.toString();
      }

      return val;
    },
  );

  // only includes props the form uses
  return pick(values, Object.keys(defaults));
}

export function toMimes(accept) {
  return accept
    .split(',')
    .map((a) => a.trim())
    .map((a) => (a.includes('/') ? a : mimer(a)));
}

export function validateFiles(filesList, {
  accept,
  maxSize,
} = {}) {
  const files = Array.from(filesList);

  // check the files' size
  if (
    maxSize
    && files.find((f) => f.size > maxSize)
  ) {
    return 'maxSize';
  }
  // check acceptable files' types
  if (accept) {
    const mimes = toMimes(accept);

    if (!files.find((f) => mimes.includes(f.type))) {
      return 'accept';
    }
  }

  return null;
}
